import { useContext } from 'react';

import { PeriodContext } from '../context';
import { PeriodContextProps } from '../context/types';

export function useAnalyticsPeriod(): PeriodContextProps {
    return useContext(PeriodContext);
}
